import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=b81eba90"
import script from "./HeaderBar.ts?vue&type=script&lang=ts&external"
export * from "./HeaderBar.ts?vue&type=script&lang=ts&external"
import style0 from "./HeaderBar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports